import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select.tsx";
import { SearchIcon } from "lucide-react";
import { Input } from "@/components/ui/input.tsx";
import { useEffect, useRef, useState } from "react";
import { useDebounce } from "@/lib/hooks/use-debounce.ts";
import { useDashboardParams } from "@/lib/hooks/admin/use-dashboard-params.ts";
import { MentorsSelect } from "@/components/dashboard/mentors-select.tsx";

interface FiltersProps {
  status: string;
  mentorId: string;
}

export function Filters({ status, mentorId }: FiltersProps) {
  const { handleFilterChange, search: urlSearch } = useDashboardParams();
  const [search, setSearch] = useState("");
  const isMounted = useRef(false);

  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    if (isMounted.current) {
      handleFilterChange("search", debouncedSearch);
    }
    isMounted.current = true;
  }, [debouncedSearch]);

  useEffect(() => {
    if (urlSearch) {
      setSearch(decodeURIComponent(urlSearch));
    } else {
      setSearch("");
    }
  }, [urlSearch]);

  return (
    <div className="grid grid-cols-5 grid-rows-1 items-center gap-3 px-1 py-2">
      <Select
        value={status}
        onValueChange={(newStatus) => {
          handleFilterChange("status", newStatus);
        }}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="active">Active</SelectItem>
          <SelectItem value="inactive">Inactive</SelectItem>
        </SelectContent>
      </Select>

      <MentorsSelect
        mentorId={mentorId}
        handleFilterChange={handleFilterChange}
      />

      <div></div>
      <div></div>

      <Input
        placeholder="Search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        startIcon={<SearchIcon className="h-5 w-5" />}
        className="w-72s w-full rounded-md"
        type="search"
      />
    </div>
  );
}
